import { Component, OnInit } from '@angular/core';
import { DocumentService } from '../../../../api/services/document.service';
import { ImageService } from '../../../../api/services/image.service';

@Component({
    selector: 'app-export-clinical-data',
    templateUrl: './export-clinical-data.component.html',
    styleUrls: ['./export-clinical-data.component.css'],
})
export class ExportClinicalDataComponent implements OnInit {
    categories: { key: string; label: string; hasSubCategories?: boolean }[] = [];
    documentSubCategories: { key: string; label: string }[] = [];
    selectedData: { [key: string]: boolean | { [subKey: string]: boolean } } = {};

    constructor(private docservice: DocumentService, private imageservice: ImageService)
    {

    }

    ngOnInit(): void {
        this.initializeCategories();
        this.initializeSelectionState();
    }

    initializeCategories(): void {
        const preferencesMap: { [key: string]: string } = {
            allergies: 'Allergies',
            charges: 'Charges',
            documents: 'Documents',
            financials: 'Financials',
            images: 'Images',
            medications: 'Medications',
            notes: 'Notes',
            orders: 'Orders',
            problems: 'Problems',
            significantEvents: 'Significant Events',
            visits: 'Visits',
            vitals: 'Vitals',
        };

        this.categories = Object.keys(preferencesMap).map((key) => ({
            key,
            label: preferencesMap[key],
            hasSubCategories: key === 'documents' || key === 'images' ,
            
        }));

        if (this.categories.some((category) => category.key === 'documents')) {
            this.loadDocumentSubCategories();
        }


        if (this.categories.some((category) => category.key === 'images')) {
            this.LoaddistinctImageList();
        }
    }

    initializeSelectionState(): void {
        this.categories.forEach((category) => {
            if ((category.key === 'documents' && category.hasSubCategories) || (category.key === 'images' && category.hasSubCategories)) {
                this.selectedData[category.key] = {};
            } else {
                this.selectedData[category.key] = false;
            }
        });
    }

    toggleDocuments(): void {
        const subCategories = this.selectedData['documents'] as { [subKey: string]: boolean } || this.selectedData['images'] as { [subKey: string]: boolean };
        const allChecked = Object.values(subCategories).every((value) => value);

        Object.keys(subCategories).forEach((subKey) => {
            subCategories[subKey] = !allChecked;
        });

        this.selectedData['documents'] = !allChecked;

        this.selectedData['images'] = !allChecked;
    }

   

    exportData(): void {
        const exportPayload = this.categories.reduce((acc, category) => {
            if ((category.key === 'documents' && category.hasSubCategories) || (category.key === 'images' && category.hasSubCategories)) {
                acc[category.key] = Object.keys(
                    this.selectedData[category.key] as { [subKey: string]: boolean }
                ).filter(
                    (subKey) => (this.selectedData[category.key] as { [subKey: string]: boolean })[subKey]
                );
            } else if (this.selectedData[category.key]) {
                acc[category.key] = true;
            }
            return acc;
        }, {});

        console.log('Exporting Data:', exportPayload);
    }


    // Check if a subcategory is selected
    getSubCategorySelection(subKey: string): boolean {
        const subCategories = this.selectedData['documents'] as { [subKey: string]: boolean } || this.selectedData['images'] as { [subKey: string]: boolean };
        return subCategories[subKey] || false;
    }

    

    loadDocumentSubCategories(): void {
        this.docservice
            .documentGetcategorylistbypatient({
                patientId: sessionStorage.getItem('ptId'),
                emrpracticeId: localStorage.getItem('EmrPracticeId'),
            })
            .subscribe((result) => {
                this.documentSubCategories = result.map((category) => ({
                    key: category.categoryId,
                    label: category.categoryName,
                }));
            });
    }


   


    toggleCategorySelection(key: string, isChecked: boolean): void {
        if (key === 'documents' || key === 'images') {
            if ((!this.selectedData['documents'] || typeof this.selectedData['documents'] === 'boolean') || (!this.selectedData['images'] || typeof this.selectedData['images'] === 'boolean') ) {
                // Initialize the subcategories if they are not already initialized
                this.selectedData['documents'] = {};
                this.selectedData['images'] = {};

                this.documentSubCategories.forEach((subCategory) =>
                {
                    (this.selectedData['documents'] as { [subKey: string]: boolean })[subCategory.key] = isChecked;

                    (this.selectedData['images'] as { [subKey: string]: boolean })[subCategory.key] = isChecked;


                });
            } else {
                // Update all subcategories
                Object.keys(this.selectedData['documents'] as { [subKey: string]: boolean }).forEach((subKey) =>
                {
                    (this.selectedData['documents'] as { [subKey: string]: boolean })[subKey] = isChecked;
                });

                Object.keys(this.selectedData['images'] as { [subKey: string]: boolean }).forEach((subKey) => {
                    (this.selectedData['images'] as { [subKey: string]: boolean })[subKey] = isChecked;
                });
            }
        }

        // Set the main category state (only for non-subcategory categories)
        if (key !== 'documents') {
            this.selectedData[key] = isChecked;
        }

        if (key !== 'images') {
            this.selectedData[key] = isChecked;
        }
    }


    setSubCategorySelection(subKey: string, isChecked: boolean): void {
        if (typeof this.selectedData['documents'] === 'boolean' || !this.selectedData['documents'])
        {
            this.selectedData['documents'] = {}; // Ensure it's initialized as an object
        }

        // Update the specific subcategory
        (this.selectedData['documents'] as { [subKey: string]: boolean })[subKey] = isChecked;
        // Update the main "Documents" checkbox state


        if (typeof this.selectedData['images'] === 'boolean' || !this.selectedData['images']) {
            this.selectedData['images'] = {}; // Ensure it's initialized as an object
        }

        // Update the specific subcategory
        (this.selectedData['images'] as { [subKey: string]: boolean })[subKey] = isChecked;
        // Update the main "Documents" checkbox state
        this.updateDocumentSelection();
    }

    updateDocumentSelection(): void {
        if ((typeof this.selectedData['documents'] !== 'object') || (typeof this.selectedData['images'] !== 'object') )
        {
            this.selectedData['documents'] = {};

            this.selectedData['images'] = {};
        }

        const subCategories = this.selectedData['documents'] as { [subKey: string]: boolean } || this.selectedData['images'] as { [subKey: string]: boolean };
        const allChecked = Object.values(subCategories).every((value) => value);
        const noneChecked = Object.values(subCategories).every((value) => !value);

        if (allChecked) {
            this.selectedData['documents'] = true;
            this.selectedData['images'] = true;
        } else if (noneChecked) {
            this.selectedData['documents'] = false;
            this.selectedData['images'] = false;
        } else {
            this.selectedData['documents'] = subCategories; // Keep subcategories object

            this.selectedData['images'] = subCategories; // Keep subcategories object
        }


        ///



    }




    LoaddistinctImageList(): void {
        this.imageservice
            .imageGetcategorylistbypatient({
                patientId: sessionStorage.getItem('ptId'),
                emrpracticeId: localStorage.getItem('EmrPracticeId'),
            })
            
               // this.distinctImageList = result
            .subscribe((result) => {

              
                  this.documentSubCategories = result.map((category) => ({
                      key: category.categoryId,
                      label: category.categoryName,
                  }));

               
            })
    }


   

}
